import styled from "@emotion/styled";

export const MarketingMaterialsPageToolbarContainer = styled.div({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	flexWrap: "wrap",
	gap: "16px"
});

export const MarketingMaterialsPageFilterContainer = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	gap: "8px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "flex-start",
		gap: "16px",
		"& .MuiAutocomplete-root": {
			width: "100%"
		}
	}
}));
